import React from "react";
import LegalPage from "Pages/Legal";
import privacyData from "data/privacy-policy.json";

const PrivacyPolicy: React.FC = () => <LegalPage legalDoc={privacyData} />;

export default PrivacyPolicy;